import React, { Component, Fragment } from 'react';
import { connect } from "react-redux";
import {
    actionAddProperty, actionAddPropertyToGIRE, actionGetPropertyDetails,
    actionRemoveCities,
    actionRemoveCountries, actionRemoveStates, actionUpdateProperty, actionUploadPropertyImage,
    getAllCountry, getAmenities, getCities,
    getPropertyCategory,
    getPropertySubCategory, getStates, getUnitOfMeasures
} from "../../actions/propertysAction";
import SelectSearch from 'react-select-search';
// import '../../assets/sass/elements/_react-select-search.scss'
import classnames from 'classnames'
import CommonInputField from "./CommonInputField";
import CommonSelectWithInput from "./CommonSelectWithInput";
import CommonSelectField from "./CommonSelectField";
import CommonTextBox from "./CommonTextBox";
import CommonPagerSelect from "./CommonPagerSelect";
import companyPlaceholder from '../../assets/img/company-logo-placeholder.png'
import ReactCrop from "react-image-crop";
import "react-image-crop/dist/ReactCrop.css";
import btnLoader from "../../assets/img/button-loader.svg";
import moment from "moment";
import ToggleSwitch from "../common/Button/toggleSwitch";
import { ADD_PROPERTIES, CHAT } from "../../actions/types";
import Navbar from "../common/navbar/Navbar";
import { Form, FormGroup, Input, Label } from "reactstrap";
import { actionConnectToGRIRE } from "../../actions/auth";
import jwt_decode from 'jwt-decode';
import HeroSection from "../common/HerroSection/hero-section";
import gireLogo from '../../assets/img/gire-logo.png'


class AddProperty extends Component {
    constructor(props) {
        super(props);
        this.state = {
            category_name: '',
            sub_category_name: '',
            category_id: "",
            sub_category_id: "",
            carpet_area: "",
            area_unit_id: '',
            super_area: '',
            builder_name: '',
            list_date: moment(new Date).format('YYYY-MM-DD'),
            owner_name: '',
            title: '',
            plot_area: '',
            authority_approval: '',
            floor_allowed_for_construction: '',
            address: '',
            street: '',
            country_id: '',
            state_id: '',
            city_id: '',
            zip_code: '',
            direction: '',
            name_of_industrial_estate: '',
            construction_status: '',
            floor_availability: '',
            units_on_floor: '',
            facing: '',
            furnished_status: '',
            boundary_wall: '',
            type_of_ownership: '',
            no_of_open_sides: '',
            overlooking: '',
            flat_type: '',
            transaction_type: '',
            home_size: '',
            bedroom: '',
            bathrooms: '',
            status: '',
            currency: 'INR',
            description: '',
            car_parking: '',
            leed_certificate: '',
            no_of_cabins: '',
            no_of_conf_room: '',
            washroom: '',
            pantry: '',
            fire_equipment: '',
            age_of_property: '',
            gated_colony: '',
            corner_plot: '',
            rera_id: '',
            flooring: '',
            landmarks: '',
            pre_leased_property: '',
            booking_amount: '',
            building_class: '',
            uploadedImagePreview: '',
            image: '',
            type: '',
            propertyImgLoader: false,

            src: null,
            crop: {
                unit: 'px',
                height: 299,
                aspect: 16 / 9,
            },
            blob: '',
            amenities: [],
            email: '',
            password: '',
            isPostGire: false,
            errors: {},
            area_unit: '',
        }

    }

    componentDidMount() {
        document.title = "Add-Property | Prime Private Network";
        this.props.getPropertyCategory();
        this.props.getAmenities();
        this.props.getAllCountry();
        this.props.getUnitOfMeasures();
        if (this.props.match.params.id) {
            this.props.actionGetPropertyDetails(this.props.match.params.id)
        }
        //
    }

    componentDidUpdate(prevProps, NextState) {
        const { categories, subCategories, getPropertyDetails, unitOfMeasures } = this.props.property;


        // (prevProps.property.categories !== categories && categories.length < 1) && this.props.getPropertyCategory();
        (prevProps.property.categories !== this.props.property.categories && this.props.property.categories.length < 1) && this.props.getPropertyCategory();
        (prevProps.property.amenities !== this.props.property.amenities && this.props.property.amenities.length < 1) && this.props.getAmenities();
        // (prevProps.property.categories !== this.props.property.categories && this.props.property.categories.length < 1) && this.props.getPropertySubCategory(this.state.category_id);
        (prevProps.property.unitOfMeasures !== this.props.property.unitOfMeasures && this.props.property.unitOfMeasures.length < 1) && this.props.getUnitOfMeasures();
        ;

        if (prevProps.property.categories !== categories && categories) {
            console.log("fitst Update");
            (categories && categories.length > 0) && this.setState({
                category_id: categories[0]._id,
                category_name: categories[0].name,
            },
                () => {
                    this.props.getPropertySubCategory(this.state.category_id)

                })
        }
        if (prevProps.property.unitOfMeasures !== unitOfMeasures && unitOfMeasures) {
            if (unitOfMeasures && unitOfMeasures.length > 0) {
                this.setState({ area_unit_id: unitOfMeasures[0]._id, area_unite: unitOfMeasures[0].name })
            }
        }


        if (prevProps.property.subCategories !== subCategories && this.state.sub_category_id !== subCategories[0]._id) {

            if (NextState.sub_category_id !== subCategories[0]._id) {
                console.log("fitst Update11");

                subCategories && this.setState({
                    sub_category_id: subCategories[0]._id,
                    sub_category_name: subCategories[0].name
                }, () => this.props.getPropertySubCategory(this.state.category_id))
            }

        }


        // if (prevProps.match.params.id !== this.props.match.params.id) {
        //     this.props.actionGetPropertyDetails(this.props.match.params.id)
        // }

        //
        // if (NextState.category_id !== this.state.category_id) {
        //     console.log("cchasgy")
        // }

        if (prevProps.property.getPropertyDetails !== getPropertyDetails && getPropertyDetails) {
            console.log(getPropertyDetails, "subCategories===Update");
            // getPropertyDetails.length>0&&getPropertyDetails.map(data => {
            (getPropertyDetails) && this.setState({
                ...this.state,
                ...getPropertyDetails,
                category_id: getPropertyDetails.category ? getPropertyDetails.category._id : '',
                category_name: getPropertyDetails.category ? getPropertyDetails.category.name : '',
                sub_category_id: getPropertyDetails.subcategory ? getPropertyDetails.subcategory._id : '',
                sub_category_name: getPropertyDetails.subcategory ? getPropertyDetails.subcategory.name : '',
                country_id: getPropertyDetails.country._id,
                state_id: getPropertyDetails.state._id,
                city_id: getPropertyDetails.city._id,
                area_unit_id: getPropertyDetails.unit_of_measures ? getPropertyDetails.unit_of_measures._id : '',
                area_unit: getPropertyDetails.unit_of_measures ? getPropertyDetails.unit_of_measures.name : '',
                uploadedImagePreview: getPropertyDetails.image,
                list_date: moment(getPropertyDetails.list_date).format('YYYY-MM-DD'),
                amenities: getPropertyDetails.amenities.map(data => data._id),
                image: getPropertyDetails.image.split('/')[4]
            }, () => {
                this.props.getPropertySubCategory(this.state.category_id)
                this.props.getStates(this.state.country_id);
                this.props.getCities(this.state.state_id);
            })

            // } )


        }
        // (NextState.country_id !== this.state.country_id) && this.props.getStates(this.state.country_id);
        // (NextState.state_id !== this.state.state_id && !this.props.property.cities) && this.props.getCities(this.state.state_id);

        if (prevProps.gireAuth !== this.props.gireAuth) {
            console.log("gire Auth")
            this.setState({ isPostGire: false, })

        }

    }
    onClear = () => {
        this.setState({

            carpet_area: "",
            super_area: '',
            builder_name: '',
            list_date: moment(new Date).format('YYYY-MM-DD'),
            owner_name: '',
            title: '',
            plot_area: '',
            authority_approval: '',
            floor_allowed_for_construction: '',
            address: '',
            street: '',
            zip_code: '',
            direction: '',
            name_of_industrial_estate: '',
            construction_status: '',
            floor_availability: '',
            units_on_floor: '',
            facing: '',
            furnished_status: '',
            boundary_wall: '',
            type_of_ownership: '',
            no_of_open_sides: '',
            overlooking: '',
            flat_type: '',
            transaction_type: '',
            home_size: '',
            bedroom: '',
            bathrooms: '',
            status: '',
            description: '',
            car_parking: '',
            leed_certificate: '',
            no_of_cabins: '',
            no_of_conf_room: '',
            washroom: '',
            pantry: '',
            fire_equipment: '',
            age_of_property: '',
            gated_colony: '',
            corner_plot: '',
            rera_id: '',
            flooring: '',
            landmarks: '',
            pre_leased_property: '',
            booking_amount: '',
            building_class: '',
            uploadedImagePreview: '',
            // image: '',
            type: '',
            propertyImgLoader: false,

            src: null,
            crop: {
                unit: 'px',
                height: 299,
                aspect: 16 / 9,
            },
            blob: '',
            amenities: [],
            email: '',
            password: '',
            isPostGire: false,
            errors: {},
            area_unit: '',
        })
    };
    onChangeCategory = (e, name) => {
        if (!this.props.match.params.id) {
            console.log("onChangeCategory");
            this.onClear();
        }
        this.setState({
            [e.target.name]: e.target.value,
            category_name: name
        }, () => this.props.getPropertySubCategory(this.state.category_id));
    };



    onChangeSubCategory = (e, name) => {
        if (!this.props.match.params.id) {
            console.log("onChangeSubCategory ");
            this.onClear();
        }
        this.setState({ [e.target.name]: e.target.value, sub_category_name: name });
    }

    onChangePagerValue = (name, value) => this.setState({ [name]: value });

    onChange = e => {
        if (e.target.name === "carpet_area") {
            this.setState({ carpet_area: e.target.value.replace(/\D/g, '') })
        } else if (e.target.name === "super_area") {
            this.setState({ super_area: e.target.value.replace(/\D/g, '') })
        } else if (e.target.name === "plot_area") {
            this.setState({ plot_area: e.target.value.replace(/\D/g, '') })
        } else if (e.target.name === "floor_availability") {
            this.setState({ floor_availability: e.target.value.replace(/\D/g, '') })
        } else if (e.target.name === "no_of_open_sides") {
            this.setState({ no_of_open_sides: e.target.value.replace(/\D/g, '') })
        } else if (e.target.name === "home_size") {
            this.setState({ home_size: e.target.value.replace(/\D/g, '') })
        } else if (e.target.name === "price") {
            this.setState({ price: e.target.value.replace(/\D/g, '') })
        } else if (e.target.name === "age_of_property") {
            this.setState({ age_of_property: e.target.value.replace(/\D/g, '') })
        } else if (e.target.name === "booking_amount") {
            this.setState({ booking_amount: e.target.value.replace(/\D/g, '') })
        } else this.setState({ [e.target.name]: e.target.value })
    };


    /*  Image Crop */
    onSelectFile = e => {


        if (e.target.files && e.target.files.length > 0) {
            const reader = new FileReader();
            reader.addEventListener('load', () =>
                this.setState({ src: reader.result })
            );
            reader.readAsDataURL(e.target.files[0]);


        }


    };


    // If you setState the crop in here you should return false.
    onImageLoaded = image => {
        this.imageRef = image;
    };

    onCropComplete = crop => {
        this.makeClientCrop(crop);
    };

    onCropChange = (crop, percentCrop) => {
        // You could also use percentCrop:
        // this.setState({ crop: percentCrop });
        this.setState({ crop });
    };

    async makeClientCrop(crop) {
        if (this.imageRef && crop.width && crop.height) {
            const croppedImageUrl = await this.getCroppedImg(
                this.imageRef,
                crop,
                'newPropertyImgFile.jpeg'
            );
            this.setState({ croppedImageUrl });
        }
    }

    getCroppedImg(image, crop, fileName) {

        const canvas = document.createElement("canvas");
        const scaleX = image.naturalWidth / image.width;
        const scaleY = image.naturalHeight / image.height;
        var originWidth = crop.width * scaleX;
        var originHeight = crop.height * scaleY;
        // maximum width/height
        var maxWidth = 1200, maxHeight = 1200 / (16 / 8);
        var targetWidth = originWidth,
            targetHeight = originHeight;
        if (originWidth > maxWidth || originHeight > maxHeight) {
            if (originWidth / originHeight > maxWidth / maxHeight) {
                targetWidth = maxWidth;
                targetHeight = Math.round(maxWidth * (originHeight / originWidth));
            } else {
                targetHeight = maxHeight;
                targetWidth = Math.round(maxHeight * (originWidth / originHeight));
            }
        }
        // set canvas size
        canvas.width = targetWidth;
        canvas.height = targetHeight;
        const ctx = canvas.getContext("2d");

        ctx.drawImage(
            image,
            crop.x * scaleX,
            crop.y * scaleY,
            crop.width * scaleX,
            crop.height * scaleY,
            0,
            0,
            targetWidth,
            targetHeight
        );

        return new Promise((resolve, reject) => {
            canvas.toBlob(blob => {
                if (!blob) {
                    //reject(new Error('Canvas is empty'));
                    return;
                }
                blob.name = fileName;
                window.URL.revokeObjectURL(this.fileUrl);
                this.fileUrl = window.URL.createObjectURL(blob);
                resolve(this.fileUrl);
                this.setState({ blob }) //added by SO huy nguyen
            }, 'image/jpeg');
        });
    }

    setPropertyImagePreview = (uploadedImagePreview, image) => this.setState({ uploadedImagePreview, image });

    handlePropertyImgChange = async (e) => {
        const config = { responseType: 'blob' };
        /*let file = axios.get(this.state.croppedImageUrl, config).then(response => {
            new File([response.data], 'my_image.png', {type: "image/jpg", lastModified: new Date()});
        });*/
        var file = new File([this.state.croppedImageUrl], "property_image.png", {
            type: "image/png",
            lastModified: new Date()
        });
        let formData = new FormData();
        console.log(this.state.blob, " this.state.blob");
        formData.append('image', this.state.blob);
        // formData.append('image', file);

        this.setState({ propertyImgLoader: true }, document.getElementById('close-profilePictureUpload') && document.getElementById('close-profilePictureUpload').click());
        try {
            await this.props.actionUploadPropertyImage(formData, this.setPropertyImagePreview);
            this.setState({
                propertyImgLoader: false,
                src: null,
                blob: ''
            }, () => document.getElementById('property-img-selector').value = '');
        }
        catch (error) {
            this.setState({ propertyImgLoader: false });
        }
    };


    /*  Image Crop Ends */


    onSelectAmenity = (value) => this.state.amenities.filter(p => p === value).length ?
        this.setState({ amenities: [...this.state.amenities.filter(p => p !== value)] })
        :
        this.setState({ amenities: [...this.state.amenities, value] });


    handleValidation = () => {
        let fields = this.state;
        let errors = {};
        let formIsValid = true;

        if (!fields.price) {
            formIsValid = false;
            errors.price = "Price Required!";
        }
        if (!fields.city_id) {
            formIsValid = false;
            errors.city_id = "City Required!";
        }
        if (!fields.state_id) {
            formIsValid = false;
            errors.state_id = "State Required!";
        }
        if (!fields.country_id) {
            formIsValid = false;
            errors.country_id = "Country Required!";
        }
        if (!fields.type) {
            formIsValid = false;
            errors.type = "Please Select Property Post Type ";
        }
        this.setState({ errors: errors }, () => {
            const ID = Object.keys(errors)[0];
            document.getElementById(ID) && document.getElementById(ID).scrollIntoView();
        });
        //return formIsValid;

        if ((this.state.category_name === "Residential") && (this.state.sub_category_name === "Flat")) {

            if ((!fields.carpet_area) && (!fields.super_area)) {
                formIsValid = false;
                errors.carpet_area = "Carpet area Required!";
                errors.super_area = "Super area Required!";
            } else if ((fields.carpet_area) && (fields.super_area)) {
                errors.carpet_area = "Carpet area or Super area  Required!"
                errors.super_area = "Super area or Carpet area Required!"
            }

            if (!fields.area_unit_id) {
                formIsValid = false;
                errors.area_unit_id = "Area Unit Required!";
            }

            if (!fields.builder_name) {
                formIsValid = false;
                errors.builder_name = "Builder Name Required!";
            }

            if (!fields.address) {
                formIsValid = false;
                errors.address = "Address Required!";
            }
            if (!fields.street) {
                formIsValid = false;
                errors.street = "Street Required!";
            }
            if (!fields.zip_code) {
                formIsValid = false;
                errors.zip_code = "Zip code Required!";
            }
            if (!fields.city_id) {
                formIsValid = false;
                errors.city_id = "City Name Required!";
            }
            if (!fields.country_id) {
                formIsValid = false;
                errors.country_id = "Country Name Required!";
            }
            if (!fields.state_id) {
                formIsValid = false;
                errors.state_id = "State Name Required!";
            }
            if (!fields.age_of_property) {
                formIsValid = false;
                errors.age_of_property = "Age Of Property Required!";
            }
            if (!fields.price) {
                formIsValid = false;
                errors.price = "Price Required!";
            }
            this.setState({ errors: errors }, () => {
                const ID = Object.keys(errors)[0];
                document.getElementById(ID) && document.getElementById(ID).scrollIntoView();
            });
            return formIsValid;

        }
        if ((this.state.category_name === "Residential") && (this.state.sub_category_name === "House/Vila")) {

            if ((!fields.carpet_area) && (!fields.super_area)) {
                formIsValid = false;
                errors.carpet_area = "Carpet area Required!";
                errors.super_area = "Super area Required!";
            } else if ((fields.carpet_area) && (fields.super_area)) {
                errors.carpet_area = "Carpet area or Super area  Required!"
                errors.super_area = "Super area or Carpet area Required!"

            }

            if (!fields.builder_name) {
                formIsValid = false;
                errors.builder_name = "Builder Name Required!";
            }
            if (!fields.area_unit_id) {
                formIsValid = false;
                errors.area_unit_id = "Area Unit Required!";
            }

            if (!fields.address) {
                formIsValid = false;
                errors.address = "Address Required!";
            }
            if (!fields.street) {
                formIsValid = false;
                errors.street = "Street Required!";
            }
            if (!fields.zip_code) {
                formIsValid = false;
                errors.zip_code = "Zip code Required!";
            }
            if (!fields.city_id) {
                formIsValid = false;
                errors.city_id = "City Name Required!";
            }
            if (!fields.country_id) {
                formIsValid = false;
                errors.country_id = "Country Name Required!";
            }
            if (!fields.state_id) {
                formIsValid = false;
                errors.state_id = "State Name Required!";
            }
            if (!fields.age_of_property) {
                formIsValid = false;
                errors.age_of_property = "Age Of Property Required!";
            }
            if (!fields.price) {
                formIsValid = false;
                errors.price = "Price Required!";
            }
            this.setState({ errors: errors }, () => {
                const ID = Object.keys(errors)[0];
                document.getElementById(ID) && document.getElementById(ID).scrollIntoView();
            });
            return formIsValid;

        }
        if ((this.state.category_name === "Residential") && (this.state.sub_category_name === "Plot/Land")) {

            if (!fields.land_area) {
                formIsValid = false;
                errors.land_area = "Land /Plot Area Required!";
            }
            if (!fields.owner_name) {
                formIsValid = false;
                errors.owner_name = "Owner Name Required!";
            }
            if (!fields.area_unit_id) {
                formIsValid = false;
                errors.area_unit_id = "Area Unit Required!";
            }

            if (!fields.address) {
                formIsValid = false;
                errors.address = "Address Required!";
            }
            if (!fields.street) {
                formIsValid = false;
                errors.street = "Street Required!";
            }
            if (!fields.zip_code) {
                formIsValid = false;
                errors.zip_code = "Zip code Required!";
            }
            if (!fields.city_id) {
                formIsValid = false;
                errors.city_id = "City Name Required!";
            }
            if (!fields.country_id) {
                formIsValid = false;
                errors.country_id = "Country Name Required!";
            }
            if (!fields.state_id) {
                formIsValid = false;
                errors.state_id = "State Name Required!";
            }
            if (!fields.age_of_property) {
                formIsValid = false;
                errors.age_of_property = "Age Of Property Required!";
            }
            if (!fields.price) {
                formIsValid = false;
                errors.price = "Price Required!";
            }
            this.setState({ errors: errors }, () => {
                const ID = Object.keys(errors)[0];
                document.getElementById(ID) && document.getElementById(ID).scrollIntoView();
            });
            return formIsValid;

        }
        if ((this.state.category_name === "Commercial") && (this.state.sub_category_name === "Office")) {

            if ((!fields.carpet_area) && (!fields.super_area)) {
                formIsValid = false;
                errors.carpet_area = "Carpet area Required!"
                errors.super_area = "Super area Required!";
            } else if ((fields.carpet_area) && (fields.super_area)) {
                errors.carpet_area = "Carpet area or Super area  Required!"
                errors.super_area = "Super area or Carpet area Required!"

            }

            if (!fields.area_unit_id) {
                formIsValid = false;
                errors.area_unit_id = "Area Unit Required!";
            }
            if (!fields.builder_name) {
                formIsValid = false;
                errors.builder_name = "Builder Name Required!";
            }
            if (!fields.title) {
                formIsValid = false;
                errors.title = "Title Required!";
            }
            if (!fields.address) {
                formIsValid = false;
                errors.address = "Address Required!";
            }
            if (!fields.street) {
                formIsValid = false;
                errors.street = "Street Required!";
            }
            if (!fields.zip_code) {
                formIsValid = false;
                errors.zip_code = "Zip code Required!";
            }
            if (!fields.city_id) {
                formIsValid = false;
                errors.city_id = "City Name Required!";
            }
            if (!fields.country_id) {
                formIsValid = false;
                errors.country_id = "Country Name Required!";
            }
            if (!fields.furnished_status) {
                formIsValid = false;
                errors.furnished_status = "Furnished Status Required!";
            }
            if (!fields.state_id) {
                formIsValid = false;
                errors.state_id = "State Name Required!";
            }
            if (!fields.age_of_property) {
                formIsValid = false;
                errors.age_of_property = "Age Of Property Required!";
            }
            if (!fields.price) {
                formIsValid = false;
                errors.price = "Price Required!";
            }
            this.setState({ errors: errors }, () => {
                const ID = Object.keys(errors)[0];
                document.getElementById(ID) && document.getElementById(ID).scrollIntoView();
            });
            return formIsValid;

        }
        if ((this.state.category_name === "Commercial") && (this.state.sub_category_name === "Shop")) {


            if (!fields.title) {
                formIsValid = false;
                errors.title = "Title Required!";
            }
            if (!fields.area_unit_id) {
                formIsValid = false;
                errors.area_unit_id = "Area Unit Required!";
            }

            if (!fields.furnished_status) {
                formIsValid = false;
                errors.furnished_status = "Furnished Status Required!";
            }
            if (!fields.address) {
                formIsValid = false;
                errors.address = "Address Required!";
            }
            if (!fields.owner_name) {
                formIsValid = false;
                errors.owner_name = "Owner Name Required!";
            }

            if (!fields.zip_code) {
                formIsValid = false;
                errors.zip_code = "Zip code Required!";
            }

            if (!fields.age_of_property) {
                formIsValid = false;
                errors.age_of_property = "Age Of Property Required!";
            }
            if (!fields.price) {
                formIsValid = false;
                errors.price = "Price Required!";
            }
            if (!fields.city_id) {
                formIsValid = false;
                errors.city_id = "City Name Required!";
            }
            if (!fields.country_id) {
                formIsValid = false;
                errors.country_id = "Country Name Required!";
            }
            if (!fields.state_id) {
                formIsValid = false;
                errors.state_id = "State Name Required!";
            }

            this.setState({ errors: errors }, () => {
                const ID = Object.keys(errors)[0];
                document.getElementById(ID) && document.getElementById(ID).scrollIntoView();
            });
            return formIsValid;

        }
        if ((this.state.category_name === "Commercial") && (this.state.sub_category_name === "Showroom")) {

            if ((!fields.carpet_area) && (!fields.super_area)) {
                formIsValid = false;
                errors.carpet_area = "Carpet area Required!"
                errors.super_area = "Super area Required!";
            } else if ((fields.carpet_area) && (fields.super_area)) {
                errors.carpet_area = "Carpet area or Super area  Required!"
                errors.super_area = "Super area or Carpet area Required!"

            }

            if (!fields.area_unit_id) {
                formIsValid = false;
                errors.area_unit_id = "Area Unit Required!";
            }

            if (!fields.builder_name) {
                formIsValid = false;
                errors.builder_name = "Builder Name Required!";
            }
            if (!fields.address) {
                formIsValid = false;
                errors.address = "Address Required!";
            }
            if (!fields.street) {
                formIsValid = false;
                errors.street = "Street Required!";
            }
            if (!fields.zip_code) {
                formIsValid = false;
                errors.zip_code = "Zip code Required!";
            }
            if (!fields.city_id) {
                formIsValid = false;
                errors.city_id = "City Name Required!";
            }
            if (!fields.country_id) {
                formIsValid = false;
                errors.country_id = "Country Name Required!";
            }
            if (!fields.state_id) {
                formIsValid = false;
                errors.state_id = "State Name Required!";
            }
            if (!fields.age_of_property) {
                formIsValid = false;
                errors.age_of_property = "Age Of Property Required!";
            }
            if (!fields.price) {
                formIsValid = false;
                errors.price = "Price Required!";
            }

            if (!fields.title) {
                formIsValid = false;
                errors.title = "Title Required!";
            }
            if (!fields.furnished_status) {
                formIsValid = false;
                errors.furnished_status = "Furnished Status Required!";
            }
            this.setState({ errors: errors }, () => {
                const ID = Object.keys(errors)[0];
                document.getElementById(ID) && document.getElementById(ID).scrollIntoView();
            });
            return formIsValid;

        }
        if ((this.state.category_name === "Commercial") && (this.state.sub_category_name === "Industrial Building")) {

            if ((!fields.carpet_area) && (!fields.super_area)) {
                formIsValid = false;
                errors.carpet_area = "Carpet area Required!"
                errors.super_area = "Super area Required!";
            } else if ((fields.carpet_area) && (fields.super_area)) {
                errors.carpet_area = "Carpet area or Super area  Required!"
                errors.super_area = "Super area or Carpet area Required!"

            }


            if (!fields.area_unit_id) {
                formIsValid = false;
                errors.area_unit_id = "Area Unit Required!";
            }
            if (!fields.builder_name) {
                formIsValid = false;
                errors.builder_name = "Builder Name Required!";
            }
            if (!fields.address) {
                formIsValid = false;
                errors.address = "Address Required!";
            }
            if (!fields.street) {
                formIsValid = false;
                errors.street = "Street Required!";
            }
            if (!fields.zip_code) {
                formIsValid = false;
                errors.zip_code = "Zip code Required!";
            }

            if (!fields.age_of_property) {
                formIsValid = false;
                errors.age_of_property = "Age Of Property Required!";
            }
            if (!fields.price) {
                formIsValid = false;
                errors.price = "Price Required!";
            }

            if (!fields.city_id) {
                formIsValid = false;
                errors.city_id = "City Name Required!";
            }
            if (!fields.country_id) {
                formIsValid = false;
                errors.country_id = "Country Name Required!";
            }
            if (!fields.state_id) {
                formIsValid = false;
                errors.state_id = "State Name Required!";
            }

            if (!fields.title) {
                formIsValid = false;
                errors.title = "Title Required!";
            }
            if (!fields.furnished_status) {
                formIsValid = false;
                errors.furnished_status = "Furnished Status Required!";
            }
            this.setState({ errors: errors }, () => {
                const ID = Object.keys(errors)[0];
                document.getElementById(ID) && document.getElementById(ID).scrollIntoView();
            });
            return formIsValid;

        }
        if ((this.state.category_name === "Commercial") && (this.state.sub_category_name === "Industrial Land")) {

            if (!fields.land_area) {
                formIsValid = false;
                errors.land_area = "Land /Plot Area Required!";
            }
            if (!fields.title) {
                formIsValid = false;
                errors.title = "Title Required!";
            }
            if (!fields.owner_name) {
                formIsValid = false;
                errors.owner_name = "Owner Name Required!";
            }
            if (!fields.area_unit_id) {
                formIsValid = false;
                errors.area_unit_id = "Area Unit Required!";
            }
            if (!fields.address) {
                formIsValid = false;
                errors.address = "Address Required!";
            }

            if (!fields.street) {
                formIsValid = false;
                errors.street = "Street Required!";
            }

            if (!fields.zip_code) {
                formIsValid = false;
                errors.zip_code = "Zip code Required!";
            }

            if (!fields.age_of_property) {
                formIsValid = false;
                errors.age_of_property = "Age Of Property Required!";
            }
            if (!fields.price) {
                formIsValid = false;
                errors.price = "Price Required!";
            }
            if (!fields.city_id) {
                formIsValid = false;
                errors.city_id = "City Name Required!";
            }
            if (!fields.country_id) {
                formIsValid = false;
                errors.country_id = "Country Name Required!";
            }
            if (!fields.state_id) {
                formIsValid = false;
                errors.state_id = "State Name Required!";
            }
            this.setState({ errors: errors }, () => {
                const ID = Object.keys(errors)[0];
                document.getElementById(ID) && document.getElementById(ID).scrollIntoView();
            });
            return formIsValid;

        }
        if ((this.state.category_name === "Commercial") && (this.state.sub_category_name === "Industrial Shed")) {

            if (!fields.land_area) {
                formIsValid = false;
                errors.land_area = "Land /Plot Area Required!";
            }

            if (!fields.area_unit_id) {
                formIsValid = false;
                errors.area_unit_id = "Area Unit Required!";
            }
            if (!fields.title) {
                formIsValid = false;
                errors.title = "Title Required!";
            }
            if (!fields.builder_name) {
                formIsValid = false;
                errors.builder_name = "Builder Name Required!";
            }
            if (!fields.address) {
                formIsValid = false;
                errors.address = "Address Required!";
            }
            if (!fields.street) {
                formIsValid = false;
                errors.street = "Street Required!";
            }

            if (!fields.zip_code) {
                formIsValid = false;
                errors.zip_code = "Zip code Required!";
            }
            if (!fields.city_id) {
                formIsValid = false;
                errors.city_id = "City Name Required!";
            }
            if (!fields.country_id) {
                formIsValid = false;
                errors.country_id = "Country Name Required!";
            }
            if (!fields.state_id) {
                formIsValid = false;
                errors.state_id = "State Name Required!";
            }

            if (!fields.age_of_property) {
                formIsValid = false;
                errors.age_of_property = "Age Of Property Required!";
            }
            if (!fields.price) {
                formIsValid = false;
                errors.price = "Price Required!";
            }
            this.setState({ errors: errors }, () => {
                const ID = Object.keys(errors)[0];
                document.getElementById(ID) && document.getElementById(ID).scrollIntoView();
            });
            return formIsValid;

        }
        if ((this.state.category_name === "Land") && (this.state.sub_category_name === "Others")) {

            if (!fields.land_area) {
                formIsValid = false;
                errors.land_area = "Land /Plot Area Required!";
            }
            if (!fields.address) {
                formIsValid = false;
                errors.address = "Address Required!";
            }
            if (!fields.owner_name) {
                formIsValid = false;
                errors.owner_name = "Owner Name Required!";
            }
            if (!fields.area_unit_id) {
                formIsValid = false;
                errors.area_unit_id = "Area Unit Required!";
            }
            if (!fields.street) {
                formIsValid = false;
                errors.street = "Street Required!";
            }
            if (!fields.zip_code) {
                formIsValid = false;
                errors.zip_code = "Zip code Required!";
            }
            if (!fields.city_id) {
                formIsValid = false;
                errors.city_id = "City Name Required!";
            }
            if (!fields.country_id) {
                formIsValid = false;
                errors.country_id = "Country Name Required!";
            }
            if (!fields.state_id) {
                formIsValid = false;
                errors.state_id = "State Name Required!";
            }


            if (!fields.price) {
                formIsValid = false;
                errors.price = "Price Required!";
            }
            this.setState({ errors: errors }, () => {
                const ID = Object.keys(errors)[0];
                document.getElementById(ID) && document.getElementById(ID).scrollIntoView();
            });
            return formIsValid;


        }

        return true;

    }


    onPropertySubmit = (e) => {
        if (this.handleValidation()) {
            // this.setState({agent_id: this.props.user.user_id})

            const { property_id, title, short_desc, agent_id, description, square_feet_area, owner_name, builder_name, status, transaction_type, furnished_status, currency, price, address, flooring, rera_id, water_availability, status_of_electricity, street, zip_code, cross_street, direction, home_size, bedroom, bathrooms, list_date, lift, floor_availability, disclaimer, land_area, authority_approval, floor_allowed_for_construction, no_of_open_sides, gated_colony, boundary_wall, car_parking, type_of_ownership, overlooking, facing, corner_plot, units_on_floor, leed_certificate, super_area, carpet_area, pantry, construction_status, building_class, booking_amount, fire_equipment, store_room, pre_leased_property, landmarks, additional_features, property_type, amenities, age_of_property, no_of_cabins, no_of_conf_room, name_of_industrial_estate, flat_type, washroom, image, area_unit } = this.state;
            const category = this.state.category_id;
            const subcategory = this.state.sub_category_id;
            const country = this.state.country_id;
            const state = this.state.state_id;
            const city = this.state.city_id;
            const unit_of_measures = this.state.area_unit_id && this.state.area_unit_id;
            const user = this.props.user._id ? this.props.user._id : '';
            const type = this.state.type;
            const propertyData = {
                user,
                property_id,
                category,
                subcategory,
                title,
                city,
                state,
                country,
                short_desc,
                agent_id,
                description,
                square_feet_area,
                builder_name,
                owner_name,
                status,
                transaction_type,
                furnished_status,
                currency,
                price,
                address,
                flooring,
                rera_id,
                water_availability,
                status_of_electricity,
                street,
                zip_code,
                cross_street,
                direction,
                home_size,
                bedroom,
                bathrooms,
                washroom,
                list_date,
                lift,
                floor_availability,
                disclaimer,
                land_area,
                authority_approval,
                floor_allowed_for_construction,
                no_of_open_sides,
                gated_colony,
                boundary_wall,
                car_parking,
                type_of_ownership,
                overlooking,
                facing,
                age_of_property,
                flat_type,
                no_of_cabins,
                no_of_conf_room,
                name_of_industrial_estate,
                corner_plot,
                units_on_floor,
                leed_certificate,
                unit_of_measures,
                super_area,
                carpet_area,
                pantry,
                construction_status,
                building_class,
                booking_amount,
                fire_equipment,
                store_room,
                pre_leased_property,
                landmarks,
                additional_features,
                property_type,
                image,
                type,
                amenities: amenities.join(','),
                // is_validate: false


            };
            const ConnectPropertyData = {
                // user,
                // property_id,
                // category,
                // subcategory,
                title,
                city,
                state,
                country,
                short_desc,
                agent_id: localStorage.gire_token ? jwt_decode(localStorage.gire_token).uid : '',
                description,
                square_feet_area,
                builder_name,
                owner_name,
                status,
                transaction_type,
                furnished_status,
                currency,
                price,
                address,
                flooring,
                rera_id,
                water_availability,
                status_of_electricity,
                street,
                zip_code,
                cross_street,
                direction,
                home_size,
                bedroom,
                bathrooms,
                washroom,
                list_date,
                lift,
                floor_availability,
                disclaimer,
                land_area,
                authority_approval,
                floor_allowed_for_construction,
                no_of_open_sides,
                gated_colony,
                boundary_wall,
                car_parking,
                type_of_ownership,
                overlooking,
                facing,
                age_of_property,
                flat_type,
                no_of_cabins,
                no_of_conf_room,
                name_of_industrial_estate,
                corner_plot,
                units_on_floor,
                leed_certificate,
                // unit_of_measures,
                super_area,
                carpet_area,
                pantry,
                construction_status,
                building_class,
                booking_amount,
                fire_equipment,
                store_room,
                pre_leased_property,
                landmarks,
                additional_features,
                property_type,
                // image,
                type,
                // amenities: amenities.join(','),
                is_validate: 'false',
                category: this.state.category_name ? this.state.category_name : '',
                sub_category: this.state.sub_category_name ? this.state.sub_category_name : '',
                area_unit,


            };
            if (this.props.match.params.id) {
                this.props.actionUpdateProperty(propertyData, this.props.history, this.props.match.params.id)
            }
            else {
                this.props.actionAddProperty(propertyData, this.props.history);

                // if (localStorage.gire_token && localStorage.gire_token.length && this.state.isPostGire) {
                //     this.props.actionAddPropertyToGIRE(ConnectPropertyData);
                // }

            }

        }

    };

    handleChange = (e) => {
        e.preventDefault();
        this.setState({ [e.target.name]: e.target.value });
    };
    handleValidationGire = () => {
        let fields = this.state;
        let errors = {};
        let formIsValid = true;

        if (fields.email.length === 0) {
            formIsValid = false;
            errors.email = "username / email  must be Required!";
        }
        if (fields.password.length === 0) {
            formIsValid = false;
            errors.password = "password must be Required!";
        }
        this.setState({ errors: errors });
        return formIsValid;
    };
    onCreateGroupSubmit = (e) => {
        e.preventDefault();
        if (this.handleValidationGire()) {
            const { email, password } = this.state;
            const request = {
                email,
                password
            };
            this.props.actionConnectToGRIRE(request, this.props.user._id);
            document.getElementById('closeBtn').click()
        }
    };

    render() {
        // console.log(jwt_decode(localStorage.gire_token).uid);
        const { categoryLoader, categories, subCategoryLoader, subCategories, getUnitOfMeasuresLoader, unitOfMeasures, getCountriesLoader, countries, getSatesLoader, states, getCitiesLoader, cities, addPropertyLoader, getPropertyDetails, amenities, amenitiesLoader } = this.props.property;
        const countryData = (countries && countries.length > 0) && countries.map(c => {
            return {
                name: c.name,
                value: c._id
            }
        });

        console.log(getPropertyDetails);

        const stateData = (states && states.length > 0) && states.map(s => ({
            name: s.name,
            value: s._id
        }));
        const cityData = (cities && cities.length > 0) && cities.map(c => ({
            name: c.name,
            value: c._id
        }));
        const { errors, category_id, sub_category_id, src, crop } = this.state;


        return (
            <Fragment>
                <Navbar scenario={ADD_PROPERTIES} />
                <HeroSection title={'Add Property'} />
                <div className="container bg-white py-1 p-5 mt-5">
                    <div className="property-container">
                        <div className="row justify-content-center mt-5">
                            <div className="col-12">
                                <form className="contact-form-wrap contact-form-bg" autoComplete="off"
                                    // onKeyDown={(e) =>  (e.code === 'Enter') && e.preventDefault()}
                                    onSubmit={e => {
                                        e.preventDefault();
                                        this.onPropertySubmit()
                                    }}>

                                    <div className="row border my-2 py-2">
                                        <div className="col-12 text-center">
                                            <h5>Choose Category</h5>
                                        </div>
                                        <div className="col-12 d-sm-flex radio_type justify-content-center ">
                                            {(categories && !categoryLoader) ? categories.map((category, index) =>
                                                <div className="form-check radio_sty" key={index}>
                                                    <input className="form-check-input" type="radio"
                                                        name="category_id"
                                                        id={category._id}
                                                        value={category._id}
                                                        checked={this.state.category_id === category._id}
                                                        onChange={(e) => this.onChangeCategory(e, category.name)} />

                                                    <label className="form-check-label mr-2"
                                                        htmlFor={category._id}>
                                                        {category.name}
                                                    </label>
                                                </div>) :
                                                categoryLoader && <div className="row">
                                                    <div className="col-12 text-center">
                                                        <i className="fa fa-spinner" /> Please Wait...
                                                    </div>
                                                </div>
                                            }

                                        </div>
                                    </div>

                                    <div className="row border my-2 py-2">
                                        <div className="col-12 text-center">
                                            <h5>Choose Sub Category</h5>
                                        </div>
                                        <div className="col-12 d-sm-flex radio_type justify-content-center">
                                            {(subCategories && !subCategoryLoader) ? subCategories.map((category, index) =>
                                                <div className="form-check radio_sty" key={index}>
                                                    <input className="form-check-input" type="radio"
                                                        name="sub_category_id"
                                                        id={category._id}
                                                        value={category._id}
                                                        checked={this.state.sub_category_id === category._id}
                                                        onChange={(e) => this.onChangeSubCategory(e, category.name)} />

                                                    <label className="form-check-label mr-2"
                                                        htmlFor={category._id}>
                                                        {category.name}
                                                    </label>
                                                </div>) :
                                                subCategoryLoader && <div className="row    ">
                                                    <div className="col-12 text-center">
                                                        <i className="fa fa-spinner" /> Please Wait...
                                                    </div>
                                                </div>

                                            }

                                        </div>
                                    </div>


                                    <div className="row mt-4 justify-content-center">

                                        <div className="col-12 ">
                                            <hr />
                                            <h5>Area</h5>
                                            <small className="text-info">(Provide either Carpet Area or Super Area)
                                            </small>
                                            <hr />
                                        </div>
                                        <div className="col-md-6 text-center mt-2">
                                            <div className="row justify-content-center">
                                                <div className="col-12 text-left"><label>Carpet Area <span
                                                    className="text-danger">*</span></label></div>
                                                <div className="col-md-8 mb-sm-3">

                                                    <div className="rld-single-input mt-0">
                                                        <input type="text"
                                                            name="carpet_area"
                                                            id="carpet_area"

                                                            value={this.state.carpet_area}
                                                            onChange={this.onChange}
                                                            className={classnames(`form-control`, {
                                                                'is-invalid': errors.carpet_area
                                                            })}
                                                            placeholder="Please Enter Carpet Area" />
                                                        {errors.carpet_area &&
                                                            <span className='text-danger'>{errors.carpet_area}</span>}
                                                    </div>
                                                </div>
                                                <div className="col-md-4">
                                                    <div className="rld-single-select">
                                                        <select id="area_unit_id"
                                                            name="area_unit_id"
                                                            className={classnames(`form-control select single-select`, {
                                                                'is-invalid': errors.area_unit_id
                                                            })}
                                                            onChange={this.onChange}
                                                            value={this.state.area_unit_id}
                                                        >

                                                            {unitOfMeasures && unitOfMeasures.map(unit => <option
                                                                value={unit._id}
                                                                key={unit._id}
                                                            >{unit.name}</option>)}
                                                        </select>
                                                        {errors.area_unit_id &&
                                                            <span className='text-danger'>{errors.area_unit_id}</span>}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-6 text-center mt-1">
                                            <div className="row justify-content-center">
                                                <div className="col-12 text-left"><label>Super Area <span
                                                    className="text-danger">*</span></label></div>
                                                <div className="col-md-8 mb-sm-3">
                                                    <div className="rld-single-input mt-0">
                                                        <input type="text"
                                                            name="super_area"
                                                            id="super_area"
                                                            value={this.state.super_area}
                                                            onChange={this.onChange}
                                                            className={classnames(`form-control`, {
                                                                'is-invalid': errors.super_area
                                                            })}
                                                            placeholder="Please Enter Super Area" />
                                                        {errors.super_area &&
                                                            <span className='text-danger'>{errors.super_area}</span>}
                                                    </div>
                                                </div>
                                                <div className="col-md-4">
                                                    <div className="rld-single-select">
                                                        <select id="area_unit_id" name="area_unit_id"
                                                            // className="select single-select form-control"
                                                            className={classnames(`form-control select single-select`, {
                                                                'is-invalid': errors.area_unit_id
                                                            })}
                                                            onChange={this.onChange}
                                                            value={this.state.area_unit_id}
                                                        >

                                                            {unitOfMeasures && unitOfMeasures.map(unit => <option
                                                                value={unit._id}
                                                                key={unit._id}
                                                            >{unit.name}</option>)}
                                                        </select>
                                                        {errors.area_unit_id &&
                                                            <span className='text-danger'>{errors.area_unit_id}</span>}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        {(this.state.sub_category_name === "Plot/Land" || this.state.sub_category_name === "Land" || this.state.sub_category_name === "Industrial Land" || this.state.sub_category_name === "Industrial Shed" || this.state.sub_category_name === "Others") &&
                                            <div className="col-md-6 text-center mt-1">
                                                <div className="row justify-content-center">
                                                    <div className="col-12 text-left"><label>Land / Plot Area <span
                                                        className="text-danger">*</span></label></div>
                                                    <div className="col-md-8 mb-sm-3">
                                                        <div className="rld-single-input mt-0">
                                                            <input type="text"
                                                                name="land_area"
                                                                id="land_area"
                                                                value={this.state.land_area}
                                                                onChange={this.onChange}
                                                                className={classnames(`form-control`, {
                                                                    'is-invalid': errors.land_area
                                                                })}
                                                                placeholder="Please Enter Plot Area" />
                                                            {errors.land_area &&
                                                                <span className='text-danger'>{errors.land_area}</span>}
                                                        </div>
                                                    </div>
                                                    <div className="col-md-4">
                                                        <div className="rld-single-select">
                                                            <select id="area_unit_id" name="area_unit_id"
                                                                // className="select single-select form-control"
                                                                className={classnames(`form-control select single-select`, {
                                                                    'is-invalid': errors.area_unit_id
                                                                })}
                                                                onChange={this.onChange}
                                                                value={this.state.area_unit_id}
                                                            >

                                                                {unitOfMeasures && unitOfMeasures.map(unit => <option
                                                                    value={unit._id}
                                                                    key={unit._id}
                                                                >{unit.name}</option>)}
                                                            </select>
                                                            {errors.area_unit_id &&
                                                                <span className='text-danger'>{errors.area_unit_id}</span>}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        }
                                    </div>

                                    <div className="form-row">
                                        {(this.state.sub_category_name === "Flat" || this.state.sub_category_name === "House/Vila" || this.state.sub_category_name === "Office" || this.state.sub_category_name === "Showroom" || this.state.sub_category_name === "Industrial Building" || this.state.sub_category_name === "Industrial Shed" || this.state.sub_category_name === "Warehouse") &&
                                            <CommonInputField
                                                type={'text'}
                                                name={'builder_name'}
                                                label={'Builder Name'}
                                                placeholder={'Please Enter Builder Name (Owner Name)'}
                                                value={this.state.builder_name}
                                                onChange={this.onChange}
                                                error={errors.builder_name}
                                                require={true}
                                            />}

                                        {(this.state.sub_category_name === "Plot/Land" || this.state.sub_category_name === "Shop" || this.state.sub_category_name === "Industrial Land" || this.state.sub_category_name === "Land" || this.state.sub_category_name === "Others") &&
                                            <CommonInputField
                                                require={true}
                                                type={'date'}
                                                name={'list_date'}
                                                label={'Listing Date'}
                                                placeholder={'List Date'}
                                                value={this.state.list_date}
                                                onChange={this.onChange}
                                                error={errors.list_date}

                                            />}

                                        {(this.state.sub_category_name === "Plot/Land" || this.state.sub_category_name === "Shop" || this.state.sub_category_name === "Industrial Land" || this.state.sub_category_name === "Others") &&
                                            <CommonInputField
                                                require={true}
                                                type={'text'}
                                                name={'owner_name'}
                                                label={'Owner Name'}
                                                placeholder={'Please Enter Owner Name(Builder Name)'}
                                                value={this.state.owner_name}
                                                onChange={this.onChange}
                                                error={errors.owner_name}

                                            />}
                                        <CommonInputField
                                            type={'text'}
                                            name={'title'}
                                            label={'Title'}
                                            placeholder={'title'}
                                            value={this.state.title}
                                            onChange={this.onChange}
                                            error={errors.title}
                                        //require={true}

                                        />

                                        {/*{(this.state.sub_category_name === "Plot/Land" || this.state.sub_category_name === "Shop" || this.state.sub_category_name === "Showroom" || this.state.sub_category_name === "Industrial Building" || this.state.sub_category_name === "Industrial Land" || this.state.sub_category_name === "Industrial Shed " || this.state.sub_category_name === "Warehouse") &&
                                        <CommonInputField
                                            type={'text'}
                                            name={'title'}
                                            label={'Title'}
                                            placeholder={'title'}
                                            value={this.state.title}
                                            onChange={this.onChange}
                                            error={errors.title}
                                            require={true}

                                        />}*/}
                                        {/* {(this.state.sub_category_name === "Plot/Land" || this.state.sub_category_name === "Industrial Land" || this.state.sub_category_name === "Industrial Shed" || this.state.sub_category_name === "Others") &&
                                            <CommonSelectWithInput
                                                type={'text'}
                                                name={'plot_area'}
                                                label={'Plot Area'}
                                                onSelectChange={this.onChange}
                                                placeholder={'Plot Area'}
                                                svalue={this.state.area_unit_id}
                                                selectData={unitOfMeasures && unitOfMeasures}
                                                value={this.state.plot_area}
                                                onChange={this.onChange}
                                                error={errors.plot_area}
                                                require={true}
                                            />} */}

                                        {(this.state.sub_category_name === "Plot/Land" || this.state.sub_category_name === "Others") &&
                                            <CommonInputField
                                                type={'text'}
                                                name={'authority_approval'}
                                                label={'Authority Approval'}
                                                placeholder={'Authority Approval'}
                                                value={this.state.authority_approval}
                                                onChange={this.onChange}
                                                error={errors.authority_approval}
                                                require={true}

                                            />}
                                        {(this.state.sub_category_name === "Plot/Land") &&
                                            <CommonSelectField
                                                name={'floor_allowed_for_construction'}
                                                onChange={this.onChange}
                                                error={errors.floor_allowed_for_construction}
                                                label={'Floor allowed for Construction'}
                                                value={this.state.floor_allowed_for_construction}
                                                data={['YES', 'NO']} />}

                                        {(this.state.sub_category_name === "Flat" || this.state.sub_category_name === "House/Vila") &&
                                            <CommonInputField
                                                name={'list_date'}
                                                onChange={this.onChange}
                                                error={errors.list_date}
                                                type={'date'}
                                                label={'List Date'}
                                                value={this.state.list_date}
                                                min={'0000-01-01'}
                                                max={this.state.list_date}
                                                placeholder={'Please Enter List Date'}

                                            />}

                                        <div className="col-12 ">
                                            <hr />
                                            <h5>Address</h5>
                                            <small className="text-info">(Provide city, state etc.)

                                            </small>
                                            <hr />
                                        </div>

                                        <CommonTextBox
                                            name={'address'}
                                            onChange={this.onChange}
                                            error={errors.address}
                                            label={'Address'}
                                            value={this.state.address}
                                            required={true}
                                            placeholder={' Enter Address'}
                                        />
                                        <CommonInputField
                                            type={'text'}
                                            name={'street'}
                                            onChange={this.onChange}
                                            error={errors.street}
                                            label={'Street'}
                                            value={this.state.street}
                                            require={true}
                                            placeholder={'Please Enter Street'}
                                        />


                                        <div className="form-group col-md-6">
                                            <label htmlFor="inputEmail4">Country <span className="text-danger">*</span></label>
                                            <SelectSearch
                                                options={countryData ? countryData : []}
                                                value={this.state.country_id}
                                                onChange={(country_id) => this.setState({
                                                    country_id,
                                                    state_id: '',
                                                    city_id: ''
                                                }, () => {
                                                    this.props.actionRemoveStates();
                                                    this.props.getStates(country_id)
                                                })}

                                                name="country_id"
                                                id="country_id"
                                                autoComplete="none"
                                                placeholder="Choose your country"
                                                disabled={!countryData.length}
                                                search={true} />
                                            {errors.country_id &&
                                                <span className='text-danger'>{errors.country_id}</span>}
                                        </div>


                                        <div className="form-group col-md-6">
                                            <label htmlFor="inputEmail4">State <span
                                                className="text-danger">*</span></label>
                                            <SelectSearch
                                                options={stateData ? stateData : []}
                                                // getOptions={(query) => this.props.getStates(this.state.country_id)}
                                                value={this.state.state_id}
                                                onChange={(state_id) => this.setState({
                                                    state_id,
                                                    city_id: ''
                                                }, () => {
                                                    this.props.actionRemoveCities();
                                                    this.props.getCities(state_id);

                                                })}
                                                name="state_id"
                                                id="state_id"
                                                autoComplete="none"
                                                placeholder="Choose your state"
                                                disabled={!this.state.country_id}
                                                search={true} />

                                            {errors.state_id &&
                                                <span className='text-danger'>{errors.state_id}</span>}
                                        </div>
                                        <div className="form-group col-md-6">
                                            <label htmlFor="inputEmail4">City <span
                                                className="text-danger">*</span></label>
                                            <SelectSearch
                                                options={cityData ? cityData : []}
                                                // getOptions={(query) => this.props.actionGetCity(`state_id=${this.state.state_id}&q=${query}`)}
                                                value={this.state.city_id && this.state.city_id}
                                                onChange={(city_id) => this.setState({ city_id })}
                                                name="city_id"
                                                id="city_id"
                                                autoComplete="none"
                                                placeholder="Choose your city"
                                                disabled={!this.state.state_id || !this.state.country_id}
                                                search={true} />
                                            {errors.city_id &&
                                                <span className='text-danger'>{errors.city_id}</span>}
                                        </div>
                                        <CommonInputField
                                            type={'text'}
                                            name={'zip_code'}
                                            onChange={this.onChange}
                                            error={errors.zip_code}
                                            label={'Zip Code'}
                                            value={this.state.zip_code}
                                            require={true}
                                            placeholder={'Please Enter Zip Code'}
                                        />
                                        {(this.state.sub_category_name === "Flat" || this.state.sub_category_name === "House/Vila") &&
                                            <CommonInputField
                                                type={'text'}
                                                name={'direction'}
                                                onChange={this.onChange}
                                                error={errors.direction}
                                                label={'Direction'}
                                                value={this.state.direction}
                                                //require={true}
                                                placeholder={'Please Enter Direction'}
                                            />}

                                        <div className="col-12 ">
                                            <hr />
                                            <h5>Property Details</h5>
                                            <small className="text-info">(Provide number of units – i.e. bathrooms,
                                            bedrooms, conference room, parking etc.)

                                            </small>
                                            <hr />
                                        </div>


                                        {(this.state.sub_category_name === "Industrial Building" || this.state.sub_category_name === "Industrial Land" || this.state.sub_category_name === "Industrial Shed" || this.state.sub_category_name === "Warehouse") &&
                                            <CommonInputField
                                                type={'text'}
                                                name={'name_of_industrial_estate'}
                                                onChange={this.onChange}
                                                error={errors.name_of_industrial_estate}
                                                label={'Name Of Industrial Estate'}
                                                value={this.state.name_of_industrial_estate}
                                                require={true}
                                                placeholder={'Name Of Industrial Estate (IDE / SEZ)'}
                                            />}

                                        {(this.state.sub_category_name === "Office" || this.state.sub_category_name === "Shop" || this.state.sub_category_name === "Showroom" || this.state.sub_category_name === "Industrial Building") &&
                                            <CommonSelectField
                                                name={'construction_status'}
                                                onChange={this.onChange}
                                                error={errors.construction_status}
                                                label={'Construction Status'}
                                                value={this.state.construction_status}
                                                data={['YES', 'NO']} />}


                                        {(this.state.sub_category_name === "Office" || this.state.sub_category_name === "Shop" || this.state.sub_category_name === "Showroom" || this.state.sub_category_name === "Industrial Building" || this.state.sub_category_name === "Warehouse") &&
                                            <CommonInputField
                                                type={'text'}
                                                name={'floor_availability'}
                                                onChange={this.onChange}
                                                error={errors.floor_availability}
                                                label={'Floor availability'}
                                                value={this.state.floor_availability}
                                                require={true}
                                                placeholder={'e.g 14'}
                                            />}

                                        {(this.state.sub_category_name === "Office" || this.state.sub_category_name === "Shop" || this.state.sub_category_name === "Showroom" || this.state.sub_category_name === "Industrial Building" || this.state.sub_category_name === "Warehouse") &&
                                            <CommonInputField
                                                type={'text'}
                                                name={'units_on_floor'}
                                                onChange={this.onChange}
                                                error={errors.units_on_floor}
                                                label={'Units on Floor'}
                                                value={this.state.units_on_floor}
                                                require={true}
                                                placeholder={'Units on Floor'}
                                            />}
                                        {(this.state.sub_category_name === "Office") &&
                                            <CommonSelectField
                                                name={'facing'}
                                                onChange={this.onChange}
                                                error={errors.facing}
                                                label={'Facing'}
                                                value={this.state.facing}
                                                data={['East', 'West', 'North', 'South']} />}


                                        {(this.state.sub_category_name === "Office" || this.state.sub_category_name === "Shop" || this.state.sub_category_name === "Showroom" || this.state.sub_category_name === "Industrial Building") &&
                                            <CommonSelectField
                                                name={'furnished_status'}
                                                onChange={this.onChange}
                                                error={errors.furnished_status}
                                                label={'Furnished Status'}
                                                value={this.state.furnished_status}
                                                //require={true}
                                                data={['YES', 'NO']} />}


                                        {(this.state.sub_category_name === "Plot/Land" || this.state.sub_category_name === "Industrial Land" || this.state.sub_category_name === "Industrial Shed" || this.state.sub_category_name === "Others") &&
                                            <CommonSelectField
                                                name={'boundary_wall'}
                                                onChange={this.onChange}
                                                error={errors.boundary_wall}
                                                label={'Boundary Wall'}
                                                value={this.state.boundary_wall}
                                                require={false}
                                                data={['YES', 'NO']} />}


                                        {(this.state.sub_category_name === "Plot/Land" || this.state.sub_category_name === "Office" || this.state.sub_category_name === "Shop" || this.state.sub_category_name === "Showroom" || this.state.sub_category_name === "Industrial Building" || this.state.sub_category_name === "Industrial Land" || this.state.sub_category_name === "Industrial Shed" || this.state.sub_category_name === "Others" || this.state.sub_category_name === "Warehouse") &&
                                            <CommonInputField
                                                type={'text'}
                                                name={'type_of_ownership'}
                                                onChange={this.onChange}
                                                error={errors.type_of_ownership}
                                                label={'Type Of Ownership'}
                                                placeholder={'Type Of Ownership'}
                                                value={this.state.type_of_ownership}
                                                require={false}
                                            />}

                                        {(this.state.sub_category_name === "Plot/Land" || this.state.sub_category_name === "Industrial Land" || this.state.sub_category_name === "Industrial Shed" || this.state.sub_category_name === "Others" || this.state.sub_category_name === "Warehouse") &&
                                            <CommonInputField
                                                type={'text'}
                                                name={'no_of_open_sides'}
                                                onChange={this.onChange}
                                                error={errors.no_of_open_sides}
                                                label={'Number Of Open Sides'}
                                                placeholder={'Number Of Open Sides'}
                                                value={this.state.no_of_open_sides}
                                                require={false}
                                            />}

                                        {(this.state.sub_category_name === "Plot/Land") &&
                                            <CommonSelectField
                                                name={'overlooking'}
                                                onChange={this.onChange}
                                                error={errors.overlooking}
                                                label={'Overlooking'}
                                                value={this.state.overlooking}
                                                require={false}
                                                data={['Garden', 'Park']} />}

                                        {(this.state.sub_category_name === "Flat") &&
                                            <CommonSelectField
                                                name={'flat_type'}
                                                onChange={this.onChange}
                                                error={errors.flat_type}
                                                label={'Flat Type'}
                                                value={this.state.flat_type}
                                                require={false}
                                                data={['1BHK', '2BHK', '3BHK', '4BHK', '5BHK']} />}

                                        {(this.state.sub_category_name === "House/Vila") &&
                                            <CommonSelectField
                                                name={'flat_type'}
                                                onChange={this.onChange}
                                                error={errors.flat_type}
                                                label={'House/Vila Type'}
                                                value={this.state.flat_type}
                                                require={false}
                                                data={['1BHK', '2BHK', '3BHK', '4BHK', '5BHK', '6BHK', '6+BHK']} />}

                                        <CommonSelectField
                                            name={'transaction_type'}
                                            onChange={this.onChange}
                                            error={errors.transaction_type}
                                            label={'Transaction Type'}
                                            value={this.state.transaction_type}
                                            require={false}
                                            data={['New Property', 'Resell Property']} />

                                        {(this.state.sub_category_name === "Flat" || this.state.sub_category_name === "House/Vila") &&
                                            <CommonInputField
                                                type={'text'}
                                                name={'home_size'}
                                                onChange={this.onChange}
                                                error={errors.home_size}
                                                label={'Home Size'}
                                                placeholder={'Home Size (Sq Feet)'}
                                                value={this.state.home_size}
                                                require={false}
                                            />}

                                        {(this.state.sub_category_name === "Flat" || this.state.sub_category_name === "House/Vila") &&
                                            <CommonPagerSelect
                                                name={'bedroom'}
                                                label={'Bedrooms'}
                                                value={this.state.bedroom}
                                                onChange={this.onChangePagerValue}
                                                data={['1', '2', '3', '4', '5', '5+']}
                                            />}

                                        {(this.state.sub_category_name === "Flat" || this.state.sub_category_name === "House/Vila" || this.state.sub_category_name === "Industrial Building") &&
                                            <CommonPagerSelect
                                                name={'bathrooms'}
                                                label={'Bathrooms'}
                                                value={this.state.bathrooms}
                                                onChange={this.onChangePagerValue}
                                                data={['1', '2', '3', '4', '5', '6', '6+']}
                                            />}


                                        {(this.state.sub_category_name === "Flat" || this.state.sub_category_name === "House/Vila" || this.state.sub_category_name === "Industrial Land" || this.state.sub_category_name === "Industrial Shed" || this.state.sub_category_name === "Others" || this.state.sub_category_name === "Warehouse") &&
                                            <CommonSelectField
                                                name={'status'}
                                                onChange={this.onChange}
                                                error={errors.status}
                                                label={'Status'}
                                                value={this.state.status}
                                                require={false}
                                                data={['Ready To Move', 'Work In Progress']} />}

                                        {(this.state.sub_category_name === "Flat" || this.state.sub_category_name === "House/Vila") &&
                                            <CommonSelectField
                                                name={'furnished_status'}
                                                onChange={this.onChange}
                                                error={errors.furnished_status}
                                                label={'Furnished Status'}
                                                value={this.state.furnished_status}
                                                //require={true}
                                                data={['YES', 'NO']} />}

                                        <CommonSelectWithInput
                                            type={'text'}
                                            name={'price'}
                                            selectName={'currency'}
                                            label={'Price'}
                                            onSelectChange={this.onChange}
                                            placeholder={'Price'}
                                            svalue={this.state.currency}
                                            selectData={[{ name: 'INR', _id: 'INR' }, { name: 'USD', _id: 'USD' }]}
                                            value={this.state.price}
                                            onChange={this.onChange}
                                            error={errors.price}
                                            require={true}
                                        />
                                        <CommonTextBox
                                            name={'description'}
                                            onChange={this.onChange}
                                            error={errors.description}
                                            label={'Description'}
                                            value={this.state.description}
                                            //required={false}
                                            placeholder={'Please Enter Description'} />


                                        {(this.state.sub_category_name === "Flat" || this.state.sub_category_name === "House/Vila" || this.state.sub_category_name === "Office" || this.state.sub_category_name === "Showroom" || this.state.sub_category_name === "Industrial Building") &&
                                            <CommonSelectField
                                                name={'car_parking'}
                                                onChange={this.onChange}
                                                error={errors.car_parking}
                                                label={'Car Parking'}
                                                value={this.state.car_parking}
                                                require={false}
                                                data={['No', '1', '2', '3', '4', '5']} />}


                                        {(this.state.sub_category_name === "Office" || this.state.sub_category_name === "Shop" || this.state.sub_category_name === "Showroom" || this.state.sub_category_name === "Industrial Building" || this.state.sub_category_name === "Industrial Land" || this.state.sub_category_name === "Industrial Shed" || this.state.sub_category_name === "Warehouse") &&

                                            <CommonInputField
                                                type={'text'}
                                                name={'leed_certificate'}
                                                onChange={this.onChange}
                                                error={errors.leed_certificate}
                                                label={'LEED Certificate'}
                                                placeholder={'LEED Certificate'}
                                                value={this.state.leed_certificate}
                                                require={false}
                                            />}


                                        {(this.state.sub_category_name === "Office") &&
                                            <Fragment>
                                                <CommonPagerSelect
                                                    name={'no_of_cabins'}
                                                    label={'Number Of Cabins'}
                                                    value={this.state.no_of_cabins}
                                                    onChange={this.onChangePagerValue}
                                                    require={true}
                                                    data={['1', '2', '3', '4', '5', '6', '6+']}
                                                />
                                                <CommonPagerSelect
                                                    name={'no_of_conf_room'}
                                                    label={'Number Of conference rooms'}
                                                    value={this.state.no_of_conf_room}
                                                    onChange={this.onChangePagerValue}
                                                    require={true}
                                                    data={['1', '2', '3', '4', '5', '6', '6+']}
                                                />
                                            </Fragment>}


                                        {(this.state.sub_category_name === "Office" || this.state.sub_category_name === "Showroom") &&
                                            <CommonPagerSelect
                                                name={'washroom'}
                                                label={'Washroom'}
                                                value={this.state.washroom}
                                                onChange={this.onChangePagerValue}
                                                require={true}
                                                data={['1', '2', '3', '4', '5', '6', '6+']}
                                            />}


                                        {(this.state.sub_category_name === "Office" || this.state.sub_category_name === "Showroom" || this.state.sub_category_name === "Industrial Building") &&
                                            <CommonSelectField
                                                name={'pantry'}
                                                onChange={this.onChange}
                                                error={errors.pantry}
                                                label={'Pantry'}
                                                value={this.state.pantry}
                                                require={false}
                                                data={['YES', 'NO']} />}


                                        {(this.state.sub_category_name === "Office") &&
                                            <CommonSelectField
                                                name={'fire_equipment'}
                                                onChange={this.onChange}
                                                error={errors.fire_equipment}
                                                label={'Fire Equipment'}
                                                value={this.state.fire_equipment}
                                                require={false}
                                                data={['YES', 'NO']} />}


                                        {(this.state.sub_category_name !== "Others") &&
                                            <CommonInputField
                                                type={'text'}
                                                name={'age_of_property'}
                                                onChange={this.onChange}
                                                error={errors.age_of_property}
                                                label={'Age of property (In Year)'}
                                                placeholder={'Please Enter Age of Property (In Year)'}
                                                value={this.state.age_of_property}
                                                require={true}
                                            />}


                                        {(this.state.sub_category_name === "Industrial Land" || this.state.sub_category_name === "Industrial Shed" || this.state.sub_category_name === "Others") &&
                                            <CommonSelectField
                                                name={'gated_colony'}
                                                onChange={this.onChange}
                                                error={errors.gated_colony}
                                                label={'Gated Colony'}
                                                value={this.state.gated_colony}
                                                require={false}
                                                data={['YES', 'NO']} />}

                                        {(this.state.sub_category_name === "Plot/Land" || this.state.sub_category_name === "Shop" || this.state.sub_category_name === "Showroom" || this.state.sub_category_name === "Industrial Building" || this.state.sub_category_name === "Industrial Land" || this.state.sub_category_name === "Industrial Shed" || this.state.sub_category_name === "Others" || this.state.sub_category_name === "Warehouse") &&
                                            <CommonSelectField
                                                name={'facing'}
                                                onChange={this.onChange}
                                                error={errors.facing}
                                                label={'Facing'}
                                                value={this.state.facing}
                                                data={['East', 'West', 'North', 'South']} />}


                                        {(this.state.sub_category_name === "Plot/Land" || this.state.sub_category_name === "Industrial Land" || this.state.sub_category_name === "Others") &&
                                            <CommonSelectField
                                                name={'corner_plot'}
                                                onChange={this.onChange}
                                                error={errors.corner_plot}
                                                label={'Corner Plot'}
                                                value={this.state.corner_plot}
                                                data={['YES', 'NO']} />}


                                        {(this.state.sub_category_name !== "Flat" || this.state.sub_category_name !== "House/Vila") &&
                                            <CommonInputField
                                                type={'text'}
                                                name={'rera_id'}
                                                onChange={this.onChange}
                                                error={errors.rera_id}
                                                label={'RERA ID'}
                                                placeholder={'Please Enter RERA ID'}
                                                value={this.state.rera_id}
                                            //require={true}
                                            />}

                                        {(this.state.sub_category_name !== "House/Vila") &&
                                            <CommonInputField
                                                type={'text'}
                                                name={'flooring'}
                                                onChange={this.onChange}
                                                error={errors.flooring}
                                                label={'Flooring'}
                                                placeholder={'Please Enter Flooring'}
                                                value={this.state.flooring}
                                            //require={true}
                                            />}


                                        {(this.state.sub_category_name === "Industrial Land" || this.state.sub_category_name === "Warehouse") &&
                                            <CommonSelectField
                                                name={'floor_allowed_for_construction'}
                                                onChange={this.onChange}
                                                error={errors.floor_allowed_for_construction}
                                                label={'Floor allowed for Construction'}
                                                value={this.state.floor_allowed_for_construction}
                                                data={['YES', 'NO']} />}


                                        {(this.state.sub_category_name === "Office" || this.state.sub_category_name === "Shop" || this.state.sub_category_name === "Showroom" || this.state.sub_category_name === "Industrial Building" || this.state.sub_category_name === "Industrial Land" || this.state.sub_category_name === "Industrial Shed" || this.state.sub_category_name === "Warehouse") &&
                                            <CommonTextBox
                                                name={'disclaimer'}
                                                onChange={this.onChange}
                                                error={errors.disclaimer}
                                                label={'Disclaimer'}
                                                value={this.state.disclaimer}
                                                required={false}
                                                placeholder={'Please Enter Disclaimer'} />}

                                        {(this.state.sub_category_name === "Industrial Land" || this.state.sub_category_name === "Industrial Shed" || this.state.sub_category_name === "Warehouse" || this.state.sub_category_name === "Others" || this.state.sub_category_name === "Others") &&
                                            <CommonTextBox
                                                name={'landmarks'}
                                                onChange={this.onChange}
                                                error={errors.landmarks}
                                                label={'Landmarks'}
                                                value={this.state.landmarks}
                                                required={false}
                                                placeholder={'Please Enter Landmarks'} />}

                                        {(this.state.sub_category_name === "Industrial Land" || this.state.sub_category_name === "Industrial Shed" || this.state.sub_category_name === "Warehouse" || this.state.sub_category_name === "Others") &&
                                            <CommonSelectField
                                                name={'pre_leased_property'}
                                                onChange={this.onChange}
                                                error={errors.pre_leased_property}
                                                label={'Pre Leased Property'}
                                                value={this.state.pre_leased_property}
                                                data={['YES', 'NO']} />}


                                        {(this.state.sub_category_name === "Shop") &&
                                            <Fragment>
                                                <CommonInputField
                                                    type={'text'}
                                                    name={'booking_amount'}
                                                    onChange={this.onChange}
                                                    error={errors.booking_amount}
                                                    label={'Booking Amount'}
                                                    placeholder={'Please Enter Booking Amount'}
                                                    value={this.state.booking_amount}
                                                    require={false}

                                                />
                                                <CommonInputField
                                                    type={'text'}
                                                    name={'building_class'}
                                                    onChange={this.onChange}
                                                    error={errors.building_class}
                                                    label={'Building Class'}
                                                    placeholder={'Please Enter Building Class'}
                                                    value={this.state.building_class}
                                                    require={false}

                                                />
                                                <CommonInputField
                                                    type={'text'}
                                                    name={'store_room'}
                                                    onChange={this.onChange}
                                                    error={errors.store_room}
                                                    label={'Store Rooms'}
                                                    placeholder={'Please Enter Store Rooms'}
                                                    value={this.state.store_room}
                                                    require={false}

                                                />


                                            </Fragment>}



                                        <CommonSelectField
                                            name={'type'}
                                            onChange={this.onChange}
                                            error={errors.type}
                                            label={'Post Property Type'}
                                            value={this.state.type}
                                            require={true}
                                            //data={['PRIVATE', 'PUBLIC', 'BOTH']} />
                                            data={['PRIVATE', 'PUBLIC']} />

                                        {/*<div className="form-group col-md-6">*/}
                                        {/*<label htmlFor="inputEmail233">Private Property</label>*/}
                                        {/*<ToggleSwitch*/}
                                        {/*checked={this.state.type}*/}
                                        {/*text="Is Active"*/}
                                        {/*size={'default'}*/}
                                        {/*// disabled={this.state.disabled}*/}
                                        {/*onChange={(e) => this.setState({type: e.target.checked})}*/}
                                        {/*offstyle="btn-custom-3"*/}
                                        {/*onstyle="btn-custom-1"*/}
                                        {/*/>*/}

                                        {/*</div>*/}


                                        <div className="col-12">
                                            <div className="text-center col-6">
                                                <label>Upload Property Image</label>
                                                <img
                                                    src={this.state.uploadedImagePreview ? this.state.uploadedImagePreview : companyPlaceholder}
                                                    alt="img" className={'upload-property-img'} />
                                                {this.state.propertyImgLoader ?
                                                    <div className="add-media">
                                                        <i className="fa fa-spinner fa-pulse"
                                                            style={{
                                                                color: '#fda94f',
                                                                boxShadow: 'none',
                                                                fontSize: 25
                                                            }} />
                                                    </div> :
                                                    <div className="add-media btn btn-yellow"
                                                        data-toggle="modal"
                                                        data-target="#profilePictureUpload">
                                                        <i className="fa fa-paperclip mr-1" aria-hidden="true" />Upload
                                                        Property Image
                                                    </div>}
                                                {errors.uploadedImagePreview &&
                                                    <span className='text-danger'><br />{errors.uploadedImagePreview}</span>}
                                                <p className="font-weight-bold mt-3"><span className='text-success'>*Note:- you can add multiple images of this property after listing..</span>
                                                </p>
                                            </div>
                                        </div>

                                    </div>
                                    <hr />
                                    <div className="col-12 ">
                                        <p className="font-weight-bold mt-3"><span className='text-info'>*Note:- you can post your property of GIRE portal.</span>
                                        </p>
                                        {(localStorage.gire_token && localStorage.gire_token.length > 0) ?
                                            <button type="button" className="btn btn-gire disabled">CONNECTED TO
                                                GIRE</button> :
                                            <button type="button" className="btn btn-custom-1"
                                                id="openBroadcast"
                                                data-toggle="modal"
                                                data-tip data-for="AddGroup"
                                                data-target="#connectgire"
                                                data-backdrop="static" data-keyboard="false"
                                            >CONNECT TO GIRE</button>}
                                    </div>
                                    <hr />
                                    <div className="row">
                                        <div className="col-12 ">
                                            <hr />
                                            <h5>Platform</h5>
                                            <small className="text-info">(Select Multi-platform and post your property)
                                            </small>
                                        </div>
                                        <hr />
                                        {(localStorage.gire_token && localStorage.gire_token.length > 0) &&
                                            <div className="col-lg-6 col-xl-6 col-md-6 col-12">
                                                <div className="form-check d-flex align-items-center">
                                                    <input type="checkbox" className="form-check-input cursor-pointer"
                                                        value={this.state.isPostGire}
                                                        onChange={() => this.setState({ isPostGire: !this.state.isPostGire })}
                                                        id="is_post_gire" />
                                                    <label className="form-check-label cursor-pointer"
                                                        htmlFor="is_post_gire">Global India Realestate</label>
                                                </div>
                                            </div>}
                                        <div className="col-12 mt-2 ">
                                            <hr />
                                            <h5>Amenities</h5>
                                            <small className="text-info">(Select Amenities which suits your property)
                                            </small>
                                            <hr />
                                        </div>

                                    </div>


                                    <div className="row">

                                        {(amenities && amenities.length > 0) && amenities.map((data, index) =>
                                            <div className="col-lg-6 col-xl-6 col-md-6 col-12" key={index}>

                                                <p onClick={() => this.onSelectAmenity(data._id)}
                                                    className={classnames('text-center border rounded cursor-pointer', {
                                                        'active-amenity': this.state.amenities.filter(p => p === data._id).length
                                                    })}>

                                                    {data.name}</p>
                                            </div>
                                        )}

                                    </div>


                                    <div className="row">

                                        <div className="col-12 text-center">
                                            {addPropertyLoader ?
                                                <button
                                                    className="btn btn-success"
                                                    type="button">
                                                    <img src={btnLoader} alt="login-loader"
                                                        style={{ width: '22px', margin: '0 15px' }} />
                                                </button> :
                                                <button
                                                    className="btn btn-custom-1"
                                                    type="submit">Save Property
                                                </button>}
                                        </div>
                                    </div>

                                </form>
                            </div>
                        </div>
                    </div>
                </div>
                <Fragment>
                    <div className="modal fade" id="profilePictureUpload" role="dialog" data-backdrop="static"
                        data-keyboard="false"
                        aria-labelledby="profilePictureUploadTitle" aria-hidden="true">
                        <div className="modal-dialog modal-dialog-centered" role="document">
                            <div className="modal-content">
                                <div className="modal-header">
                                    <h5 className="modal-title" id="exampleModalLongTitle">Change Property Image</h5>
                                    <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                </div>
                                <div className="modal-body text-center">
                                    <div className="row">
                                        <div className="col-12 text-center">
                                            {src ? (
                                                <ReactCrop
                                                    src={src}
                                                    crop={crop}
                                                    ruleOfThirds
                                                    onImageLoaded={this.onImageLoaded}
                                                    onComplete={this.onCropComplete}
                                                    onChange={this.onCropChange}
                                                    className={'company-profile-preview-image'}
                                                />
                                            ) : <img width={350}
                                                src={this.state.uploadedImagePreview ? this.state.uploadedImagePreview : companyPlaceholder}
                                                alt="Property Image" />}
                                        </div>
                                    </div>
                                    <hr />
                                    <input id={'property-img-selector'} type="file" accept="image/*"
                                        onChange={this.onSelectFile} />

                                </div>
                                <div className="modal-footer">
                                    <button id={'close-profilePictureUpload'} type="button"
                                        className="btn btn-danger" data-dismiss="modal">Close
                                    </button>
                                    <button className="btn btn-success" onClick={this.handlePropertyImgChange}>Save
                                    changes
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </Fragment>
                <Fragment>
                    {/* Create Broadcast Modal */}
                    <div className="modal fade" id="connectgire" tabIndex={-1} role="dialog"
                        aria-labelledby="connectgireLabel" aria-hidden="true" style={{ marginTop: "2em" }}>
                        <div className="modal-dialog modal-dialog-centered" role="document">

                            <div className="modal-content" style={{ zIndex: '9999999999999999 !important' }}>
                                <div className="modal-header">
                                    <h5 className="modal-title w-100 text-center"
                                        id="createBroadcastModalLabel">Connect to <img src={gireLogo} style={{ width: '30px' }} alt="gire-logo" />GIRE </h5>
                                    <button type="button" id="closeBtn" className="close" data-dismiss="modal"
                                        aria-label="Close">
                                        <span aria-hidden="true h3">×</span>
                                    </button>
                                </div>
                                <div className="modal-body">
                                    <Form className='auth-forgot-password-form mt-2' autoComplete="off"
                                        noValidate={true}
                                        onSubmit={this.onCreateGroupSubmit}>
                                        <FormGroup className="p-3">
                                            <Label className='form-label' for='login-email'>
                                                Username / Email
                                            </Label>
                                            <Input type='text'
                                                className={classnames(`form-control`, {
                                                    'is-invalid': errors.email
                                                })}
                                                value={this.state.group}
                                                name="email" onChange={this.handleChange}
                                                placeholder="Enter username / email" />
                                            <Label className='form-label' for='login-email'>
                                                Password
                                            </Label>
                                            <Input type='text'
                                                className={classnames(`form-control`, {
                                                    'is-invalid': errors.password
                                                })}
                                                value={this.state.group}
                                                name="password" onChange={this.handleChange}
                                                placeholder="Enter Password" />
                                            <button type="submit"
                                                className="btn btn-secondary mt-3">Login
                                            </button>
                                        </FormGroup>
                                    </Form>
                                </div>
                            </div>
                        </div>
                    </div>
                </Fragment>
            </Fragment>
        );
    }
}


const mapStateToProps = (state) => ({
    property: state.property,
    user: state.auth.user,
    gireAuth: state.auth.gireAuth
});

export default connect(mapStateToProps, {
    getPropertyCategory,
    getPropertySubCategory,
    getAllCountry,
    actionRemoveCountries,
    actionRemoveStates,
    actionRemoveCities,
    getStates,
    getCities,
    getUnitOfMeasures,
    actionAddProperty,
    actionUploadPropertyImage,
    actionGetPropertyDetails,
    actionUpdateProperty,
    getAmenities,
    actionConnectToGRIRE,
    actionAddPropertyToGIRE,
})(AddProperty);

